import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import back from "../../../assets/back.svg";
import "../customers.css";
import { useDispatch } from "react-redux";
import { customerSubscriberRequestDetail } from "../../../redux/actions/customerActions";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import UpdateToExecutiveModal from "../../../components/modals/Customer/updateToExecutiveModal";

const CustomerSubscribeRequestView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [subscribeReqData, setSubscribeReqData] = useState(null);
  const [approveShow, setApproveShow] = useState(false);
  const [fullDataShow, setFullDataShow] = useState([]);
  const [userType, setuserType] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(customerSubscriberRequestDetail(params?.id, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    setFullDataShow(data?.data?.data);
    console.log(data);
    if (data.data.data.doctor_id) {
      setSubscribeReqData(data.data.data.doctor);
      setuserType("doctor");
    } else {
      setSubscribeReqData(data.data.data.pharmacy);
      setuserType("pharmacy");
    }
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  console.log(userType);

  const docBasicDetails = [
    {
      heading: "Jivini’s Customer Code",
      title: subscribeReqData?.code ? subscribeReqData?.code : "--",
    },
    {
      heading: "Doctor Name",
      title: subscribeReqData?.name
        ? `DR. ${subscribeReqData?.name.toUpperCase()}`
        : "--",
    },
    {
      heading: "Pharmacy Type",
      title: subscribeReqData?.pharmacy_type
        ? subscribeReqData?.pharmacy_type.charAt(0).toUpperCase() +
          subscribeReqData?.pharmacy_type.slice(1)
        : "--",
    },
    {
      heading: "Qualification",
      title: subscribeReqData?.qualification
        ? subscribeReqData?.qualification
        : "--",
    },
    {
      heading: "Specialization",
      title: subscribeReqData?.specialization?.name
        ? subscribeReqData?.specialization?.name
        : "--",
    },
    {
      heading: "MCI Number",
      title: subscribeReqData?.medical_council_registration_number
        ? subscribeReqData?.medical_council_registration_number
        : "--",
    },
  ];

  const pharmacyBasicDetails = [
    {
      heading: "Jivini’s Customer Code",
      title: subscribeReqData?.code ? subscribeReqData?.code : "--",
    },
    {
      heading: "Pharmacy Name",
      title: subscribeReqData?.pharmacy_name
        ? subscribeReqData?.pharmacy_name.toUpperCase()
        : "--",
    },
    {
      heading: "Drug License Number - 20A",
      title: subscribeReqData?.drug_licence_number_20_a
        ? subscribeReqData?.drug_licence_number_20_a
        : "--",
    },
    {
      heading: "Drug License Number - 20B",
      title: subscribeReqData?.drug_licence_number_20_b
        ? subscribeReqData?.drug_licence_number_20_b
        : "--",
    },
    {
      heading: "GST Number",
      title: subscribeReqData?.gst_number ? subscribeReqData?.gst_number : "--",
    },
  ];

  const contactDetails = [
    {
      heading: "Mobile Number",
      title: `+91 ${subscribeReqData?.mobile}`
        ? `+91 ${subscribeReqData?.mobile}`
        : "--",
    },
    {
      heading: "Alternate Mobile Number",
      title: `+91 ${subscribeReqData?.alternate_mobile}`
        ? `+91 ${subscribeReqData?.alternate_mobile}`
        : "--",
    },
    {
      heading: "Email Address",
      title: subscribeReqData?.email ? subscribeReqData?.email : "--",
    },
    {
      heading: "Address",
      title:
        subscribeReqData?.address &&
        `${subscribeReqData?.address?.address_one}, ${subscribeReqData?.address?.address_two}, ${subscribeReqData?.address?.address_three}`,
    },
    {
      heading: "Landmark",
      title: subscribeReqData?.address?.landmark
        ? subscribeReqData?.address?.landmark
        : "--",
    },
    {
      heading: "State",
      title: subscribeReqData?.state?.name
        ? subscribeReqData?.state?.name
        : "--",
    },
    {
      heading: "District",
      title: subscribeReqData?.district?.name
        ? subscribeReqData?.district?.name
        : "--",
    },
    {
      heading: "City",
      title: subscribeReqData?.city?.name ? subscribeReqData?.city?.name : "--",
    },
    {
      heading: "Pincode",
      title: subscribeReqData?.pincode ? subscribeReqData?.pincode : "--",
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/customers/subscribe-request",
      breadcrumb: " / customers / subscribe request",
    },

    {
      path: "/customers/subscribe-request/view/:id",
      breadcrumb: subscribeReqData?.code
        ? ` / ${subscribeReqData?.code} - view`
        : " / view",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <AdminButton
                  background="#2AD3E7"
                  color="white"
                  width="100px"
                  onClick={() => setApproveShow(true)}
                >
                  UPDATE
                </AdminButton>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="main-view-page">
                  <div className="mb-4">
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Basic Details
                    </div>
                    <div className="product-details-container ms-2 ps-1">
                      <div className="pt-3 row ">
                        {userType == "doctor" ? (
                          <>
                            {docBasicDetails.map((item, index) => (
                              <div
                                key={index}
                                className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container"
                              >
                                <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                  {item.heading}
                                </h5>
                                <p className={`fs_15 fn_Nunito fw_500`}>
                                  {item.title}
                                </p>
                              </div>
                            ))}
                          </>
                        ) : (
                          <>
                            {pharmacyBasicDetails.map((item, index) => (
                              <div
                                key={index}
                                className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container"
                              >
                                <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                  {item.heading}
                                </h5>
                                <p className={`fs_15 fn_Nunito fw_500`}>
                                  {item.title}
                                </p>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Contact Details
                    </div>
                    <div className="product-details-container ms-2 ps-1">
                      <div className="pt-3 row row-cols-6">
                        {contactDetails.map((item, index) => (
                          <div className="mb-2 mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 mx-0  customers-heading-container">
                            <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                              {item.heading}
                            </h5>
                            <p className={`fs_15 fn_Nunito fw_500`}>
                              {item.title}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <UpdateToExecutiveModal
            divisiondata={fullDataShow}
            data={subscribeReqData}
            show={approveShow}
            ShowClose={() => setApproveShow(false)}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </>
  );
};

export default CustomerSubscribeRequestView;
